module.exports = __webpack_public_path__ + "static/media/no-access-company-file.30f2ead5.png";